export enum SpineGroupType {
  Default = 'default',
  WinningPanel = 'WinningPanel',
  Symbol = 'Symbol',
  TableWheel = 'TableWheel',
  Table = 'Table',
  Zeus = 'Zeus',
  Pot = 'Pot',
  GiftedSymbol = 'GiftedSymbol',
  SceneSwitch = 'SceneSwitch',
}
